// add format
import util from './utils'
import getAppInfo from '@/utils/from'

export default ajv => {
  const customErrors = ajv.customErrors
  const valueStore = ajv.valueStore

  ajv.addKeyword('customValidate', {
    validate: function (schema, data, parentSchema, path, parentData, name, rootData) {
      const method = util[schema]

      if (!method) {
        console.error(`not found custom validate method: ${schema}`)
        throw new Error(`not found custom validate method: ${schema}`)
      }

      const { validate, message } = method(data, rootData, parentData)

      if (!validate) {
        const error = {
          keyword: 'customValidate',
          dataPath: path,
          message
        }

        this.errors ? this.errors.push(error) : this.errors = [error]
      }
      return validate
    }
  })

  // 用户名
  ajv.addFormat('username', function (value) {
    const customError = customErrors[customErrors.length - 1]
    const { validate, message } = util.username(value)

    if (!validate) {
      customError.push({
        value,
        message
      })
    }

    return validate
  })

  // 姓名
  // 姓#名，保证可以分开存储
  ajv.addFormat('name', function (value) {
    const customError = customErrors[customErrors.length - 1]
    const { validate, message } = util.name.nameValidate(value)

    if (!validate) {
      customError.push({
        value,
        message
      })
    }

    return validate
  })

  // 姓名-乘机人
  ajv.addFormat('passengerName', function (value) {
    const len = customErrors.length - 1
    const customError = customErrors[len]
    const { passType, isInternational } = valueStore[len]
    let { passengerType } = valueStore[len]
    passengerType = passengerType || passType
    const { validate, message } = util.name.nameValidate(value, isInternational, false, passengerType)

    if (!validate) {
      customError.push({
        value,
        message
      })
    }

    return validate
  })

  // 联系人姓名
  ajv.addFormat('contactName', function (value) {
    const len = customErrors.length - 1
    const customError = customErrors[customErrors.length - 1]
    const { firstName, lastName } = valueStore[len]
    const { validate, message } = util.name.nameValidate(`${lastName || ''}#${firstName || ''}`, false, true)

    if (!validate) {
      customError.push({
        value,
        message
      })
    }

    return validate
  })

  // 身份证
  ajv.addFormat('identityCard', function (value) {
    const customError = customErrors[customErrors.length - 1]
    const { validate, message } = util.identityCard(value)

    if (!validate) {
      customError.push({
        value,
        message
      })
    }

    return validate
  })

  const regIdNo = /^[0-9a-zA-Z]{4,50}$/
  const regIdNoFif = /^[0-9a-zA-Z]{1,15}$/
  const regTN = /^[0-9]{3}-[0-9]{10}$/
  const regEighteen = /^8[123]0000(?:19|20)\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])\d{3}[\dX]$/
  const regSpecial = /^([0-9a-zA-Z]{15}|[0-9a-zA-Z]{18})$/

  ajv.addFormat('idNo', function (value) {
    const len = customErrors.length - 1
    const customError = customErrors[len]
    let { idType } = valueStore[len]
    let valid = true
    let msg
    const fifteenNumberList = ['ID1', 'ID3', 'ID4', 'ID5', 'ID6', 'ID7', 'ID9', 'ID10', 'ID11', 'ID12', 'ID13', 'ID16', 'ID17', 'ID18', 'ID20', 'ID21', 'ID24', 'ID28', 'ID29', 'ID']
    if (idType === 'ID_CARD' || idType === 'NI') {
      // NOTE: 身份证(NI)
      const { validate, message } = util.identityCard(value)
      valid = validate
      msg = message
    } else if (idType === 'TN' || idType === 'TICKETNO') {
      // NOTE: 电子客票号 - 兼容旧逻辑
      if (!regTN.test(value)) {
        msg = `请输入正确的电子客票号，如${getAppInfo()?.ticketCode}-1234567890`
        valid = false
      }
    } else if (['HM'].includes(idType)) {
      // NOTE: 港澳台居民居住证(HM)
      if (!regEighteen.test(value)) {
        msg = '请输入正确的证件号码，该证件号码仅支持数字，长度为18位！'
        valid = false
      }
    } else if (['ID14', 'ID26'].includes(idType)) {
      // NOTE: 特殊身份证(ID26) & 外国人永久居留身份证(ID14)
      if (!regSpecial.test(value)) {
        msg = '请输入正确的证件号码，该证件号码仅支持英文、数字，长度为15或18位！'
        valid = false
      }
    } else if (fifteenNumberList.includes(idType)) {
      // NOTE: 其他的证件类型
      if (!regIdNoFif.test(value)) {
        msg = '请输入正确的号码，该证件号码仅支持英文、数字，长度1-15位！'
        valid = false
      }
    } else {
      // NOTE: 兼容旧逻辑
      const regIdNoValid = regIdNo.test(value)

      if (!regIdNoValid) {
        if (idType === 'MI_CARD' || idType === 3) {
          msg = '请输入正确的军官证件号，其证件号仅支持英文，数字，长度4-50位！'
        } else if (idType === 'PR_ID' || idType === 5) {
          msg = '请输入正确的外国人永久居留身份证，其证件号仅支持英文，数字，长度4-50位！'
        } else {
          msg = '仅支持输入英文及数字,长度4-50位！'
        }

        valid = false
      }
    }

    if (!valid) {
      customError.push({
        value,
        message: msg
      })
    }

    return valid
  })

  // 生日
  ajv.addFormat('birthday', function (value) {
    const customError = customErrors[customErrors.length - 1]
    const { validate, message } = util.birthday(value)

    if (!validate) {
      customError.push({
        value,
        message
      })
    }

    return validate
  })

  // 生日-成人
  ajv.addFormat('passengerBirthday', function (value) {
    const len = customErrors.length - 1
    const customError = customErrors[len]
    const { passType, passengerType, departureDate, departureDate2 } = valueStore[len]
    const { validate, message } = util.birthday(value, '-', passengerType || passType, departureDate, departureDate2)

    if (!validate) {
      customError.push({
        value,
        message
      })
    }

    return validate
  })

  // 国际手机号 国家代号_号码 待补充其他国家的规则
  ajv.addFormat('i18nphone', function (value) {
    const len = customErrors.length - 1
    const customError = customErrors[len]
    const { countryCode } = valueStore[len]
    const { validate, message } = util.i18nphone(value, countryCode)

    if (!validate) {
      customError.push({
        value,
        message
      })
    }

    return validate
  })
}
